export const GET_SHOP_LIST = 'GET_SHOP_LIST';
export const GET_SHOP_LIST_SUCCESS = 'GET_SHOP_LIST_SUCCESS';

